// extracted by mini-css-extract-plugin
module.exports = {"countryFlagBox":"CountryFlagIcon_countryFlagBox__flmbA","leftToRight":"CountryFlagIcon_leftToRight__YEIdI"};